import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { DetailsService } from 'src/app/common/services/details.service';

@Component({
  selector: 'rpc-eligibility',
  templateUrl: './eligibility.component.html',
  styleUrls: ['./eligibility.component.scss']
})
export class EligibilityComponent implements OnInit, OnChanges, OnDestroy {

  @Input() irbNumber?: string;

  eligibilityCriteria = '';

  private subscriptions: Subscription[] = [];
  private lastLoadedIrbNumber?: string;

  constructor(private detailsService: DetailsService) { }

  ngOnInit(): void {
    this.getEligibilityCriteria();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['irbNumber']) {
      this.getEligibilityCriteria();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /**
   * Get eligibility criteria
   */
  getEligibilityCriteria() {
    if (!this.irbNumber || this.irbNumber === this.lastLoadedIrbNumber) {
      return;
    }

    this.resetEligibilityCriteria();
    this.lastLoadedIrbNumber = this.irbNumber;
    this.subscriptions.push(
      this.detailsService.getStudyDetail(this.irbNumber).subscribe((result) => {
        this.eligibilityCriteria = result?.eligibilityCriteria ?? '';
      })
    );

  }

  /**
     * Resets Eligibility Criteria
     */
  resetEligibilityCriteria() {
    this.eligibilityCriteria = '';
  }
}